<template>
    <div class="drag_drop_root" @dragenter="onFileDragEnter" @dragover="onFileDragOver"
        @dragleave="onFileDragLeave" @drop="onFileDrop">
        <UploadComponent ref="dropUploader" class="drop_uploader" :project-id="projectId" />
        <slot />
        <div v-if="enabled && isFileDragActive" class="file_drop_overlay">
            <div class="file_drop_card">
                <i class="bi bi-cloud-upload"></i>
                <div>{{ displayMessage }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import UploadComponent from '@/components/UploadComponent.vue';

export default {
    name: 'DragDropUpload',
    components: { UploadComponent },
    props: {
        enabled: {
            type: Boolean,
            default: true
        },
        projectId: {
            type: String,
            default: null
        },
        message: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            isFileDragActive: false,
            fileDragCounter: 0
        }
    },
    computed: {
        displayMessage() {
            return this.message || this.$t('dragDrop.dropToUpload')
        }
    },
    watch: {
        enabled(val) {
            if (!val) {
                this.isFileDragActive = false
                this.fileDragCounter = 0
            }
        }
    },
    methods: {
        isFileDrag(event) {
            const dataTransfer = event?.dataTransfer
            if (!dataTransfer) {
                return false
            }
            if (dataTransfer.files && dataTransfer.files.length > 0) {
                return true
            }
            const types = Array.from(dataTransfer.types || [])
            return types.includes('Files')
        },
        onFileDragEnter(event) {
            if (!this.enabled || !this.isFileDrag(event)) {
                return
            }
            this.fileDragCounter += 1
            this.isFileDragActive = true
        },
        onFileDragOver(event) {
            if (!this.enabled || !this.isFileDrag(event)) {
                return
            }
            event.preventDefault()
            event.dataTransfer.dropEffect = 'copy'
        },
        onFileDragLeave(event) {
            if (!this.enabled || (!this.isFileDrag(event) && !this.isFileDragActive)) {
                return
            }
            this.fileDragCounter -= 1
            if (this.fileDragCounter <= 0) {
                this.fileDragCounter = 0
                this.isFileDragActive = false
            }
        },
        onFileDrop(event) {
            if (!this.enabled || !this.isFileDrag(event)) {
                return
            }
            event.preventDefault()
            this.fileDragCounter = 0
            this.isFileDragActive = false
            this.handleDroppedFiles(event.dataTransfer?.files)
        },
        handleDroppedFiles(fileList) {
            if (!fileList || fileList.length === 0) {
                return
            }
            this.$refs.dropUploader?.handleExternalFiles?.(fileList)
        }
    }
}
</script>

<style scoped>
.drag_drop_root {
    position: relative;
}

.drop_uploader {
    display: none;
}

.file_drop_overlay {
    position: fixed;
    inset: 0;
    z-index: 9999;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding-top: 15vh;
    pointer-events: none;
    backdrop-filter: blur(4px);
    -webkit-backdrop-filter: blur(4px);
}

.file_drop_card {
    width: 100%;
    max-width: 560px;
    border-radius: 12px;
    padding: 1.5rem 2rem;
    background: rgba(33, 33, 33, 0.95);
    color: #e4e4e4;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.8rem;
    font-size: 1.1rem;
    box-shadow: 0 16px 70px rgba(0, 0, 0, 0.5);
    border: 1px solid rgba(47, 47, 47, 0.8);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
}

.file_drop_card i {
    font-size: 1.5rem;
}
</style>
